import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cbf8cae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "menus" }
const _hoisted_3 = { class: "menuItem" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"93.42px"} }, null, -1))

import AppLogo from './AppLogo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const menus = [
    {
        name: '首页',
        path: '/home',
    },
    {
        name: '赛事分析报告',
        path: '/home',
    },
    {
        name: '赛事视频数据',
        path: '/home',
    },
    {
        name: '战术中心',
        path: '/home',
    },
    {
        name: '教程',
        path: '/home',
    },
    {
        name: '认证',
        path: '/home',
    },
]

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createVNode(_component_Container, null, {
        default: _withCtx(() => [
          _createVNode(AppLogo),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menus, (i) => {
              return _createVNode(_component_RouterLink, {
                key: i.name,
                to: i.path
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(i.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            }), 64))
          ])
        ]),
        _: 1
      })
    ]),
    _hoisted_4
  ], 64))
}
}

})